export function handleCaseFunction(state, handleCase1, handleCase2) {
  if (state.case1 === true) {
    handleCase1();
  } else {
    handleCase2();
  }
}

export function toggleFunction(setState, state, handleCase1, handleCase2) {
  return () => {
    setState({
      case1: (state.case1 = !state.case1),
    });
    handleCaseFunction(state, handleCase1, handleCase2);
  };
}

